export default __webpack_public_path__ + "506fc41b94206031711a672f2505d31b.svg";